import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
const opts = {
	icons: {
		iconfont: 'fa',
	},
	theme: {
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: '#4891ce',
				secondary: '#5856D5',
				accent: '#4891ce',
				error: '#F80012',
				success: '#00B358',
				warning: '#FF8C00',
				info: '#1046A9',
			},
		},
	},
}

export default new Vuetify(opts)
